module.exports = __webpack_public_path__ + "static/ARN2019-48e6ef53282401a8c14b5666a0bc5e4d.svg";